import {
  Button,
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@theprelude/ds";

export const DeleteNotificationModal = ({
  open,
  isDeleting,
  onConfirm,
  onOpenChange,
}: {
  open: boolean;
  isDeleting?: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      disableImplicitClose
      hideClose
      onEscapeKeyDown={() => {
        if (!isDeleting) {
          onOpenChange(false);
        }
      }}
    >
      <DialogHeader>
        <DialogTitle>
          Are you sure you want to delete this notification?
        </DialogTitle>
      </DialogHeader>
      <DialogBody>
        This notification will no longer be delivered to the intended
        recipients.
      </DialogBody>
      <DialogFooter>
        <DialogClose asChild>
          <Button intent="secondary" disabled={isDeleting}>
            Cancel
          </Button>
        </DialogClose>
        <Button
          intent="negative"
          loading={isDeleting}
          disabled={isDeleting}
          onClick={onConfirm}
        >
          Delete
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
